<template>
    <div class="docer-discount-alert" v-if="discount.shouldShow && show" @click.stop="hideAlert()">
        <div class="discount-image-wrapper" v-bind:class="{ loaded: imgLoaded }">
            <img class="discount-image" src="./images/discount_alert.png" @click.stop="goDiscount()" @load="imgOnload()" />
            <span class="discount-image-close" v-if="imgLoaded" @click.stop="hideAlert()" ></span>
        </div>
    </div>
</template>

<script>
    import Util from '../../assets/js/util.js';

    export default {
        data: () => ({
            show: false,
            imgLoaded: false,
        }),
        props: {
            discount: {
                type: Object
            },
        },
        created() {
            VEvts.$on('VIP_STATUS_CHANGE', userid => {
                let isVip = this.VIPUserCheck();
                if (userid && !isVip) {
                    let discount_alert_name = 'wps_discount_' + userid;
                    let hasAlert = Util.Cookie.find(discount_alert_name);
                    // 一定时间内未弹出过
                    if (!hasAlert) {
                        this.show = true;
                        Util.Cookie.create(discount_alert_name, 1, this.discount.alertIntv, '.wps.com');
                    }
                }
                if (!userid && this.show) {
                    this.show = false;
                }
            });
        },
        methods: {

            // 隐藏弹出
            hideAlert() {
                this.show = false;
                this.imgLoaded = false;
            },

            // 跳转购物车
            goDiscount() {
                Util.goAvengateCart({
                    productId: 8,
                    couponCode: this.discount.shouldShow ? this.discount.couponCode : '',
                    source: 'WPS_SUBS_V12_Docer2Vip_Signin_Discount_Popup',
                })
                Util.gaReport('send', 'event', 'signinDiscount/popup', 'click', '12 months');
            },

            //判断是否为会员
            VIPUserCheck() {
                //210为会员, cookie存1，否则为0
                return Util.Cookie.find('wps_vip') == 1 ? true : false;
            },

            // 浏览器打链接
            qingOpenUrl(url) {
                return Util.jsAsynCall('qingOpenVipUrl', {'callbackurl': url});
            },

            // 图片加载完成
            imgOnload() {
                this.imgLoaded = true;
            }
        }
    };
</script>

<style scoped>
    .docer-discount-alert {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 5;
    }

    .discount-image-wrapper {
        position: fixed;
        top: 50%;
        left: 50%;
        width: 430px;
        height: 418px;
        margin-left: -215px;
        margin-top: -209px;
        opacity: 0;
        transform: scale(0.1);
    }

    .discount-image-wrapper.loaded {
        opacity: 1;
        transform: scale(1);
        transition: all 0.3s ease;
    }

    .discount-image {
        display: block;
        cursor: pointer;
        margin: auto;
    }

    .discount-image-close {
        position: absolute;
        right: 0;
        top: 0;
        width: 45px;
        height: 45px;
        border-radius: 50%;
        background: url(/static/img/preview-ui.cdb6264.png) -297px -37px no-repeat;
        background-color: rgba(0, 0, 0, .4);
        cursor: pointer;
    }

    .discount-image-close:hover {
        background-color: rgba(0, 0, 0, .3);
    }

</style>


// WEBPACK FOOTER //
// DiscountAlert.vue?264a9fe4